module.exports = __webpack_public_path__ + "/login_ui/img/pa-4dd0dc1a450bbd6ecbfc49f9c363ba99.svg";